// let currentLanguage = 'en';

const strings = {
	app_title: {
		en: 'Dealer Reports Portal',
		fr: 'Portail de rapports du concessionnaire'
	},
	report_name: {
		en: 'Report Name',
		fr: 'Nom du rapport'
	},
	report_date: {
		en: 'Report Date',
		fr: 'Date du rapport'
	},
	modified_date: {
		en: 'Modified Date',
		fr: 'Date modifiée'
	},
	type: {
		en: 'Type',
		fr: 'Type'
	},
	frequency: {
		en: 'Frequency',
		fr: 'La fréquence'
	},
	version: {
		en: 'Version',
		fr: 'Version'
	},
	dealerCode: {
		en: 'Dealer Code',
		fr: 'Code de concessionnaire'
	},
	dealerCodes:{
		en: 'Dealer Codes',
		fr: 'Codes de concessionnaire'
	},
	reports: {
		en: 'Reports',
		fr: 'Rapports'
	},
	reportGroups: {
		en: 'Report Groups',
		fr: 'Groupes de rapport'
	},
	reportCode:{
		en: 'Report ID',
		fr: 'ID de rapport'
	},
	reportId:{
		en: 'Report Name',
		fr: 'Nom du rapport'
	},
	reportTypeId:{
		en: 'Type',
		fr: 'Type'
	},
	reportFrequencyId:{
		en: 'Frequency',
		fr: 'Fréquence'
	},
	date_range:{
		en: "Report Date Range",
		fr: "Plage de dates de rapport"
	},
	state_date:{
		en: "Start Date",
		fr: "Date de début"
	},
	end_date:{
		en: "End Date",
		fr: "Date de fin"
	},
	found: {
		en: "Found",
		fr: "Trouvé"
	},
	no_reports: {
		en: "No Reports",
		fr: "Aucun rapport"
	},
	quick_search:{
		en: "Quick Search",
		fr: "Recherche Rapide"
	},
	search: {
		en: "Search",
		fr: "Recherche"
	},
	advancedSearch: {
		en: 'Advanced Search',
		fr: 'Recherche avancée'
	},
	reset: {
		en: "Reset",
		fr: "Réinitialiser"
	},
	download_combined_pdf: {
		en: "Download combined PDF",
		fr: "Télécharger le PDF combiné"
	},
	download: {
		en: 'Download',
		fr: 'Télécharger'
	},
	sign_in: {
		en: "Sign in",
		fr: "Se connecter"
	},
	logout: {
		en: "Logout",
		fr: "Fermeture de session"
	},
	home: {
		en: "Home",
		fr: "Page d’accueil"
	},
	close: {
		en: "Close",
		fr: "Fermer"
	},
	back: {
		en: "Back",
		fr: "Retour"
	},
	select: {
		en: "Select",
		fr: "Choisir"
	},
	select_all: {
		en: "Select all",
		fr: "Tout sélectionner"
	},
	view:{
		en: "View",
		fr: "Vue"
	},
	markAsRead:{
		en: "Mark as read",
		fr: "Marquer comme lu"
	},
	language: {
		en: 'Language',
		fr: 'Lang'
	},
	user: {
		en: 'Internal User',
		fr: 'Utilisateur interne'
	},
	new_user: {
		en: "New User",
		fr: "Nouvel utilisateur"
	},
	new_report: {
		en: "New Report",
		fr: "Nouvel Rapport"
	},
	zoneUser: {
		en: 'Zone User',
		fr: 'Utilisateur de zone'
	},
	admin: {
		en: 'Internal Admin',
		fr: 'Administrateur interne'
	},
	dealer: {
		en: 'Dealer Staff',
		fr: 'Personnel du concessionnaire'
	},
	dealerAdmin: {
		en: 'Dealer Admin',
		fr: 'Administrateur de concessionnaire'
	},
	vendor: {
		en: 'Vendor',
		fr: 'Le vendeur'
	},
	superuser: {
		en: 'Superuser',
		fr: 'Superuser'
	},
	today: {
		en: 'Today',
		fr: 'Aujourd\'hui'
	},
	oneDayAgo: {
		en: '1 day ago',
		fr: 'Il y a 1 jour'
	},
	twoDaysAgo: {
		en: '2 days ago',
		fr: 'Il y a 2 jours'
	},
	threeDaysAgo: {
		en: '3 days ago',
		fr: 'Il y a 3 jours'
	},
	fourDaysAgo: {
		en: '4 days ago',
		fr: 'Il y a 4 jours'
	},
	fiveDaysAgo: {
		en: '5 days ago',
		fr: 'Il y a 5 jours'
	},
	sixDaysAgo: {
		en: '6 days ago',
		fr: 'Il y a 6 jours'
	},
	sevenDaysAgo: {
		en: '7 days ago',
		fr: 'Il y a 7 jours'
	},
	users: {
		en: 'Users',
		fr: 'Utilisateurs'
	},
	manage_reports: {
		en: 'Manage Reports',
		fr: 'Gérer les Rapports'
	},
	username: {
		en: 'Username',
		fr: "Nom d'utilisateur"
	},
	usertype: {
		en: 'User Type',
		fr: "Type d'utilisateur"
	},
	brand: {
		en: 'Brand',
		fr: 'Marque'
	},
	save: {
		en: 'Save',
		fr: 'Enregistrer'
	},
	zones: {
		en: "Zones",
		fr: "Les zones"
	},
	access_to: {
		en: "Access to",
		fr: "Accès à"
	},
	search_users: {
		en: "Search users",
		fr: "Rechercher des utilisateurs"
	},
	search_reports: {
		en: "Search reports",
		fr: "Rechercher des rapports"
	},
	session_expired: {
		en: "Your session has expired",		
		fr: "Votre session a expiré"
	},
	please_log_back_in: {
		en: "Please log back in",		
		fr: "Veuillez vous reconnecter"
	},
	timeout: {
		en: "Network timeout",
		fr: "Temporisation du réseau"
	},
	network_error: {
		en: "Network Error",
		fr: "Erreur réseau"
	},
	something_went_wrong: {
		en: "Something went wrong!",
		fr: "Quelque chose s'est mal passé!"
	},
	if_problem: {
		en: "Please try again. If the problem persists please contact support at <br> <center><a href='mailto:dtsc@toyota.ca'>dtsc@toyota.ca</a></center>",
		fr: "Veuillez réessayer. Si le problème persiste, contactez le support a <br> <center><a href='mailto:dtsc@toyota.ca'>dtsc@toyota.ca</a></center>"
	},
	signing_in: {
		en: 'Signing In',
		fr: 'Connectez-vous'
	},
	no_access: {
		en: 'Please request report access from your administrator.',
		fr: "Veuillez demander l’accès au rapport à votre administrateur."
	},
	clear_date: {
		en: 'Clear Date',
		fr: 'Effacer la date'
	},
	filter_date: {
		en: 'Filter by date',
		fr: 'Filtrer par date'
	},
	no_reports_available:{
		en: 'This report is currently not available. Please check back later.',
		fr: "Ce rapport n'est actuellement pas disponible. S'il vous plaît revenez plus tard."
	},
	maxResults: {
		en: 'Maximum results',
		fr: "Résultats maximum"
	},
	toSeeMore: {
		en: 'To see more reports, adjust the date range.',
		fr: "Pour voir plus de rapports, ajustez la plage de dates."
	},
	read: {
		en: 'Read',
		fr: "Lu"
	},
	unread: {
		en: 'Unread',
		fr: "Non lu"
	},
	code:{
		en: "Code",
		fr: "Code"
	},
	category:{
		en: "Category",
		fr: "Catégorie"
	},
	retention_policy:{
		en: "Retention Policy",
		fr: "Politique de Conservation"
	},
	retention:{
		en: "Retention",
		fr: "Conservation"
	},
	days:{
		en: "day(s)",
		fr: "jour(s)"
	},
	hasFrench:{
		en: "Has French",
		fr: "A le francais"
	},
	multiplePerDay:{
		en: "Multiple per day",
		fr: "Plusieurs par jour"
	},
	report_name_en: {
		en: 'Report Name (EN)',
		fr: 'Nom du rapport (anglais)'
	},
	report_name_fr: {
		en: 'Report Name (FR)',
		fr: 'Nom du rapport (francais)'
	},
	overwriteReport:{
		en: "Overwrite Report",
		fr: "Ecraser le rapport"
	},
	report_frequency:{
		en: "Report Frequency",
		fr: "Fréquence de Rapport"
	},
	report_type:{
		en: "Report Type",
		fr: "Type de Rapport"
	},
	report_generated_by:{
		en: "Report Generated By",
		fr: "Rapport Généré Par"
	},
	lastUpdatedBy:{
		en: "Last Updated",
		fr: "Dernière mise à jour"
	},
	delete_report:{
		en: "Delete Report",
		fr: "Supprimer le Rapport"
	},
	delete_restore_reports:{
		en: "Delete / Restore Reports",
		fr: "Supprimer / Restaurer les Rapports"
	},
	active_reports:{
		en: "Active Reports",
		fr: "Rapports Actifs"
	},
	deleted_reports:{
		en: "Deleted Reports",
		fr: "Rapports Supprimés"
	},
	delete_btn: {
		en: "Delete",
		fr: "Supprimez"
	}



};

export default {
	currentLanguage: 'en',
	dateMatch: /(\d{4})-(\d{2})-(\d{2})/,
	setLanguage: function(lang) {
		this.currentLanguage = lang;
	},
	getLanguage: function() {
		return this.currentLanguage;
	},

	// Returns the localized object key.
	// It tests is key_language exists (eg 'name_fr'), and returns just the key
	// if not (eg. 'name').
	objStr: function(obj, key) {
		var val = obj[key + '_' + this.currentLanguage];
		return val? val: obj[key];
	},
	str: function(key) {
		if(!strings[key]) {
			console.error('Missing key "' + key + '" in localization.');
			return 'ERROR: missing key ' + key;
		}
		else if(!strings[key][this.currentLanguage]){
			return strings[key]['en'];
		}
		else {
			return strings[key][this.currentLanguage];
		}
	},
	localeCode: function() {
		return this.currentLanguage=='fr' ? 'fr-CA' : 'en-CA';
	},
	parseDate: function(value) {
		// The dates come in yyyy-mm-dd format, and new Date() assumes they are in UTC
		// so the day is always the previous one, so we can't use that method, and have
		// parse the date by components.
		var parts = this.dateMatch.exec(value);
		if(parts && parts.length>=4) {
			return new Date(parseInt(parts[1]), parseInt(parts[2]-1), parseInt(parts[3]));
		}
		else {
			return new Date(value);
		}
	},
	date: function(value) {
		if(value) {
			return (this.parseDate(value)).toLocaleString(this.localeCode(), {month:'short', weekday:'short', day:'numeric', year:'numeric' });
		}
	},
	datetime: function(value) {
		if(value) {
			//Fix INC0161051 - Sorting Modified Date
			var isoDateTime = new Date(value);			
            //Fix PRB0041777 - Modified Date Error			
			var localDateString = isoDateTime.toLocaleString(this.localeCode(), {month:'short', weekday:'short', day:'numeric', year:'numeric'});			
			return localDateString + ", " + isoDateTime.toLocaleTimeString().toLowerCase();
		}
	}
}